<style src="./Styles.scss" lang="scss"></style>
<template>
  <small
    class="label-info"
    :style="{
      background: getLabelsInfo.backgroundColor || defaultColors.back,
      color: getLabelsInfo.foregroundColor || defaultColors.front,
    }"
  >
    {{ getLabelsInfo.title }}</small
  >
</template>
<script>
export default {
  props: {
    label: null,
  },
  data() {
    return {
      defaultColors: {
        back: '#000',
        front: '#fff',
      },
    };
  },
  computed: {
    existentLabels() {
      return this.$store.getters['LABELS/getLabels'];
    },
    getLabelsInfo() {
      const labelInfo = this.existentLabels.find(
        thisLabel => String(thisLabel._id) === String(this.label),
      );
      return labelInfo || {};
    },
  },
};
</script>

<style>
.label-info {
  border-radius: 0.4rem;
  padding: 0.12rem;
  margin: 1px 0;
  width: 100%;
}
</style>